module.exports = __webpack_public_path__ + "img/green.08dcdf3e.svg";